import { Alert } from '@change/ds-core-ui';

import { PetitionUnderReviewBanner } from 'src/app/shared/components/banners/petitionUnderReview';

import { usePageBanner } from './hooks/usePageBanner';

export function PageBanner() {
	const {
		data: { message, showUnderReviewBanner },
	} = usePageBanner();

	return (
		<>
			{showUnderReviewBanner && <PetitionUnderReviewBanner />}
			{message && <Alert variant="error">{message}</Alert>}
		</>
	);
}
